import React, {useEffect, useRef, useState} from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Header from './base/HeaderComponent'
import Footer from "./base/FooterComponent";
import './Login.css';
import './Profile.css';
import {
    useMeQuery,
    useAllOperatorsQuery, useCreateMutation
} from "../services/endpoints/user.api";

const ProfileAdmin = () => {
    const navigate = useNavigate(); // Usa useNavigate per ottenere la funzione di navigazione
    const [showModal, setShowModal] = useState(false);
    const [createOperator, { isLoading: isCreating }] = useCreateMutation();
    const [modalError, setModalError] = useState(null);
    const [modalSuccess, setModalSuccess] = useState(false);

    const [formData, setFormData] = useState({
        name: '',
        username: '',
        email: '',
        password: '',
        roles: ["user","leader"]
    });


    const { data: userData, isLoading: isMeLoading, isSuccess } = useMeQuery(undefined, {
        pollingInterval: 30000, // ogni 60.000 ms = 1 minuto
        skip: false, // ogni 60.000 ms = 1 minuto
    });
    const { data: operatorsData, isLoading: isOperatorsLoading, isOperatorsSuccess, refetch } = useAllOperatorsQuery(undefined, {
        pollingInterval: 30000, // ogni 60.000 ms = 1 minuto
        skip: false, // ogni 60.000 ms = 1 minuto
    });


    let finalData = userData;

    // Redirigi se non è autenticato
    useEffect(() => {
        if (isMeLoading && !isSuccess) {
            navigate("/login");
        }
    }, [isSuccess, isMeLoading, navigate]);

    const handleCreateOperator = async () => {
        setModalError(null);
        setModalSuccess(false);

        try {
            const res = await createOperator(formData).unwrap();

            setModalSuccess(true);
            setFormData({ name: '', username: '', email: '', password: '' });
            await refetch();
            // Chiudi la modal dopo 2.5 secondi
            setTimeout(() => {
                setModalSuccess(false);
                setShowModal(false);
            }, 2500);
        } catch (err) {
            console.error("Errore durante la creazione operatore:", err);
            const message = err?.data?.message || "Errore generico nella creazione";
            setModalError(message);
        }
    };


    return (
        <div>
            <Header />
            <section className="h-100 gradient-custom-2">
                <div className="container py-5 h-100">
                    <div className="row d-flex justify-content-center">
                        <div className="col col-lg-9 col-xl-8">
                            <div className="card">
                                <div
                                    className="rounded-top text-white d-flex flex-row"
                                    style={{ backgroundColor: '#000', height: '200px' }}
                                >
                                    <div className="ms-4 mt-5 d-flex flex-column" style={{ width: '150px' }}>
                                        <img
                                            src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-profiles/avatar-1.webp"
                                            alt="Generic placeholder"
                                            className="img-fluid img-thumbnail mt-4 mb-2"
                                            style={{ width: '150px', zIndex: 1 }}
                                        />
                                        {/*<button*/}
                                        {/*    type="button"*/}
                                        {/*    className="btn btn-outline-dark text-body"*/}
                                        {/*    style={{ zIndex: 1 }}*/}
                                        {/*>*/}
                                        {/*    Edit profile*/}
                                        {/*</button>*/}
                                        <button
                                            type="button"
                                            className="btn btn-success mt-2"
                                            style={{ zIndex: 1 }}
                                            onClick={() => setShowModal(true)}
                                        >
                                            Crea operatore
                                        </button>

                                    </div>
                                    <div className="ms-3" style={{ marginTop: '130px' }}>
                                        <h5>{finalData?.data.name}</h5>
                                        {/*<p>New York</p>*/}
                                    </div>
                                </div>

                                <div className="p-4 text-black bg-body-tertiary">
                                    <div className="d-flex justify-content-end text-center py-1 text-body">
                                        {/*<div className="d-flex align-items-center gap-2">*/}
                                        {/*    <span className={`status-dot ${finalData?.firestoreUser.activeSession ? "online" : "offline"}`}></span>*/}
                                        {/*    <div>*/}
                                        {/*        <p className="small text-muted mb-0">Sessione attiva</p>*/}
                                        {/*    </div>*/}
                                        {/*</div>*/}
                                        {/*<div className="px-3">*/}
                                        {/*    <p className="mb-1 h5">{finalData?.firestoreUser.numChats}</p>*/}
                                        {/*    <p className="small text-muted mb-0">Numero sessioni</p>*/}
                                        {/*</div>*/}
                                    </div>
                                </div>

                                <div className="card-body p-4 text-black">
                                    <div className="mb-5 text-body">
                                        <h5>Operatori</h5>
                                    </div>

                                    {operatorsData?.success && operatorsData.data.length > 0 ? (
                                        <div className="table-responsive">
                                            <table className="table table-striped">
                                                <thead>
                                                <tr>
                                                    <th>Username</th>
                                                    <th>Sessioni Attive</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {operatorsData.data.map((operator, index) => (
                                                    <tr key={index}>
                                                        <td>{operator.username}</td>
                                                        <td>{operator.numChats}</td>
                                                    </tr>
                                                ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : (
                                        <p className="text-muted">Nessuna operatore presente</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {showModal && (
                    <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Crea nuovo operatore</h5>
                                    <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                                </div>
                                <div className="modal-body">
                                    {modalSuccess && (
                                        <div className="alert alert-success" role="alert">
                                            Operatore creato con successo!
                                        </div>
                                    )}
                                    {modalError && (
                                        <div className="alert alert-danger" role="alert">
                                            {modalError}
                                        </div>
                                    )}

                                    <form>
                                        <div className="mb-3">
                                            <label className="form-label">Nome</label>
                                            <input type="text" className="form-control"
                                                   value={formData.name}
                                                   onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Username</label>
                                            <input type="text" className="form-control"
                                                   value={formData.username}
                                                   onChange={(e) => setFormData({ ...formData, username: e.target.value })}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Email</label>
                                            <input type="email" className="form-control"
                                                   value={formData.email}
                                                   onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Password</label>
                                            <input type="password" className="form-control"
                                                   value={formData.password}
                                                   onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                                            />
                                        </div>
                                    </form>
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={() => {
                                            setShowModal(false);
                                            setModalError(null);
                                            setModalSuccess(false);
                                            setFormData({ name: '', username: '', email: '', password: '' });
                                        }}
                                    >
                                        Chiudi
                                    </button>
                                    <button type="button" className="btn btn-primary" onClick={handleCreateOperator} disabled={isCreating}>
                                        {isCreating ? "Creazione in corso..." : "Crea"}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="modal-backdrop fade show"></div>
                    </div>
                )}

            </section>
            <Footer />
        </div>
    );

};

export default ProfileAdmin;
